import { IssueTypeFieldsAttachmentService as OvermapIssueTypeFieldsAttachmentService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class IssueTypeFieldsAttachmentService extends OvermapIssueTypeFieldsAttachmentService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
